import { render, staticRenderFns } from "./jackpot-collect.vue?vue&type=template&id=69943da0&scoped=true"
import script from "./jackpot-collect.vue?vue&type=script&lang=js"
export * from "./jackpot-collect.vue?vue&type=script&lang=js"
import style0 from "./jackpot-collect.vue?vue&type=style&index=0&id=69943da0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69943da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69943da0')) {
      api.createRecord('69943da0', component.options)
    } else {
      api.reload('69943da0', component.options)
    }
    module.hot.accept("./jackpot-collect.vue?vue&type=template&id=69943da0&scoped=true", function () {
      api.rerender('69943da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/jackpot-collect.vue"
export default component.exports